import React from 'react';
import Alert from 'antd/lib/alert';
import 'antd/lib/alert/style/index.css';
var selfStyles = require('./styles.scss');
var AlertEmptyRoundPrompt = function () { return (React.createElement(Alert, { className: selfStyles.alert, message: 'No athletes in this round', description: 'Please check back later!', showIcon: true })); };
export default AlertEmptyRoundPrompt;



//////////////////
// WEBPACK FOOTER
// ./src/imports/components/Scoreboard/components/AlertEmptyRoundPrompt.tsx
// module id = 417
// module chunks = 0